import React from 'react';
import Reflux from 'reflux';
import AppStore from '../AppStore';
import ModalStore from '../stores/ModalStore';
import SearchStore from '../stores/SearchStore';
import ModalActions from '../actions/ModalActions';
import {Link} from 'react-router-dom';
import AppActions from '../AppActions';
import SearchActions from '../actions/SearchActions';
import {Dropdown, NavItem} from 'react-materialize';
import ModalAlert from './ModalAlert';
import SearchFull from './SearchFull';
import './Header.css';

class Header extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {
            error: '',
            ip: '',
            query: '',
            title: '',
            sshUser: '',
            userLogged: false,
            searchAvailable: false
        };
        this.logout = this.logout.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.stores = [AppStore, ModalStore, SearchStore];
    }
    logout () {
        AppActions.logout();
    }
    handleSearch (event) {
        let target = event.target;
        this.setState({query: target.value});
        if (target.value.length > 1) {
            SearchActions.search(target.value);
        } else {
            SearchActions.cleanSearch();
        }
    }
    handleClick = (e) => {
        ModalActions.changeModalLoginStatus(true);
    }
    searchShow (e) {
        e.preventDefault();
        ModalActions.changeSearchModalStatus(!this.state.searchAvailable);
        this.setState({
            searchAvailable: !this.state.searchAvailable
        });
    }

    render () {
        let notLoggedOptions = (
          <li>
            <a className='newButton waves-effect waves-light' onClick={this.handleClick}>Ingresar</a>
            <ModalAlert />
          </li>
        );
        let loggedInOptions =
          <li key='dropdown' className='truncate profile-nav in-mobile-hide'>
            <Dropdown trigger={<a><div className='profileThumb'><img src={this.state.userData.profile_image.sizeSmall ? this.state.userData.profile_image.sizeSmall : '/images/icons/default.jpg'} className='responsive-img' /></div>{
      this.state.userData.name
        ? this.state.userData.name.split(' ')[0]
        : 'Perfil'
    } <i className='fa fa-angle-down dropDownHeader' aria-hidden='true' /></a>}>
              <h6 className='subtitle-drop'>Mi Cuenta</h6>
              <NavItem href={`/p/${this.state.userData.username}`}>Mi Perfil</NavItem>
              <NavItem onClick={this.logout}>Cerrar Sesión</NavItem>
            </Dropdown>
          </li>;
        let menu = (
          <ul id='nav-mobile' className='right nav-header'>
            {
              this.state.userLogged &&
              <li >
                <Link to='/notifications' className='notif in-mobile-hide'>
                  <img src='/images/icons/notif.svg' />
                  {this.state.unreadedNotifications.length > 0 && <div className='got-notif' />}
                </Link>
              </li>
            }
            {this.state.userLogged ? <li className='linesAdd in-mobile-hide' ><Link to='/new' role='button' className='newButton' >Nuevo Top5</Link></li> : ''}
            { this.state.userLogged
              ? loggedInOptions
            : notLoggedOptions
          }

            <li className={'relative ' + (this.props.home ? 'SearchBtnInit' : '')}>
              <a className={'icon-nav icon-search ' + (this.state.searchAvailable ? 'showSearch' : '')} onClick={(e) => this.searchShow(e)}>
                <span className='btn-search' />
              </a>
            </li>
          </ul>
    );
        let visibleClass = this.props.home ? 'backHome' : 'backInit';
        return (
          <div>
            <div className='back fixed'>
              <nav className={visibleClass}>
                <div className='nav-wrapper container-gral'>
                  <div className='nav-row' >
                    <Link to='/' className='brand-logo relative brandScroll'><img alt='' src='/images/icons/brand-beta.svg' className='responsive-img' /></Link>
                    {menu}
                  </div>
                </div>
              </nav>
            </div>
            <div className='clearfix' />
            <div className='space' />
            <SearchFull />

            {this.state.userLogged
            ? <div className='nav-bottom-mobile'>
              <ul>
                <li>
                  <a className='home-nav' href='/' />
                </li>
                <li>
                  <Link to='/new' role='button' className='new-top-nav' />
                </li>
                {
                  this.state.userLogged &&

                  <li>
                    <Link to='/notifications' className='notif notif-nav' >
                      {!this.state.unreadedNotifications.length > 0 && <div className='got-notif' />}
                    </Link>
                  </li>
                }
                <li>
                  <Link to={`/p/${this.state.userData.username}`} className='profile-nav-mobile'>
                    <div className='profileThumb'><img src={this.state.userData.profile_image.sizeSmall ? this.state.userData.profile_image.sizeSmall : '/images/icons/default.jpg'} className='responsive-img' /></div>
                  </Link>
                </li>
              </ul>
            </div>
            : ''}
          </div>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/sections/Header.js